<template>
  <div class="order-status">
    <h1 class="title">
      {{ text }}
      <span
        v-if="!isMiniProgram"
        class="back-order"
        v-t="'message.backOrder'"
        @click="handleBackOrder"
      />
    </h1>
    <component
      class="action"
      :is="actionCom"
      :auth-path="authPath"
      :sign-info="needSignObj"
      :verify-type="verifyType"
      :amount="amount"
      :currency="currency"
      :ali-vertify="ALI_VERTIFY"
    />
  </div>
</template>
<script>
  import { mapState, mapGetters } from 'vuex'
  import {
    ORDER_STATUS_PEND,
    ORDER_STATUS_COMPLETE,
    ORDER_STATUS_PROGRESS,
    ALI_VERTIFY
  } from '@utils/constants'
  import Complete from './StatusStrategy/Complete'
  import NeedAuth from './StatusStrategy/NeedAuth'
  import NeedCompleteOrderInfo from './StatusStrategy/NeedCompleteOrderInfo'
  import NeedPay from './StatusStrategy/NeedPay'
  import NeedPost from './StatusStrategy/NeedPost'
  import NeedSignComfirm from "./StatusStrategy/NeedSignComfirm";

  export default {
    name: 'PayStatus',
    data() {
      return {
        ALI_VERTIFY
      }
    },
    computed: {
      ...mapState('order', {
        detail: state => state.detail,
      }),
      ...mapGetters('main', ['isMiniProgram', 'authPath' , 'noneVerifyStatus','verifyType','isAliUser', 'aliOrderInvoiceHide']),
      ...mapGetters('order', ['currency', 'isInvoiceEmpty']),
      verifyStatus () {
        return this.detail.verification_status
      },
      amount () {
        const { amount, paid_amount } = this.detail
        return parseFloat(amount) - parseFloat(paid_amount)
      },
      needSignObj() {
        let arr = this.detail.un_sign_contracts || [];
        let signObj = {};
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].type === 2) {
            signObj = arr[i];
            break;
          }
          if (arr[i].type === 1) {
            signObj = arr[i];
          }
        }

        return signObj;
      },
      actionCom () {
        const actionMap = {
          0: Complete,
          1: NeedAuth,
          5: NeedCompleteOrderInfo,
          2: NeedPay,
          3: this.isAliUser ?'': NeedPost,
          4: NeedSignComfirm
        }
        let strategy = 2
        const orderStatus = this.detail.status
        if (orderStatus == ORDER_STATUS_COMPLETE) {
          // 已支付订单
          strategy = 0
          // 需填写发票信息
          if (this.isInvoiceEmpty) strategy = 3
          // 需要代付款证明/合同签署
          if (this.needSignObj.type) strategy = 4;
          // 付款水单不完整
          if (this.detail.incomplete_info_trade_count!=='0') strategy = 5
          // 需企业认证
          if (this.noneVerifyStatus) strategy = 1
        }
        return actionMap[strategy]
      },
      text () {
        const textMap = {
          [ORDER_STATUS_PEND]: this.$t('order.pending'),
          [ORDER_STATUS_PROGRESS]: this.$t('order.pending'),
          [ORDER_STATUS_COMPLETE]: this.$t('order.paid'),
        }
        return textMap[this.detail.status]
      }
    },
    methods: {
      handleBackOrder () {
        this.$router.replace(`/order`)
      }
    }
  }
</script>
<style lang="scss">
  @import './StatusStrategy/style.scss';
</style>

<style lang="scss" scoped>
  .order-status{
    display: flex;
    flex-direction: column;
    padding: 48px 0 20px;
  }
  .back-order{
    margin-left: 0.8em;
    font-weight: normal;
    font-size: 12px;
    line-height: 1;
    align-self: center;
    color: $base-color;
    cursor: pointer;
  }
</style>

